import { RadioGroup } from '@navi/web-ui/lib/components';
import { RadioOptions } from '@navi/web-ui/lib/components/RadioGroup/types';
import { Checkbox } from '@navi/web-ui/lib/primitives';
import { ChangeEvent } from 'react';
import { isOptionChecked } from './utils';
import styles from './index.module.scss';
import cx from 'classnames';
import { INormalOptionValues } from './types';

const NormalOptions = (props: INormalOptionValues) => {
  const {
    filterSchema,
    selectedFilter,
    selectedOptions,
    setSelectedOptions,
    handleCheckboxChange,
    filteredOptionsData
  } = props;
  const { isSearchEnabled, multiSelect = true } = filterSchema?.[selectedFilter] || {};

  return (
    <div
      className={cx(
        styles.filteredOptions,
        { [styles.noSearch]: !isSearchEnabled },
        { [styles.singleSelect]: !multiSelect }
      )}
    >
      {multiSelect ? (
        filteredOptionsData?.map(option => (
          <div className={styles.option} key={option?.label}>
            <Checkbox
              onChange={e => handleCheckboxChange(e, option)}
              title={option?.label as string}
              defaultChecked={isOptionChecked(
                option?.value as string,
                selectedOptions,
                selectedFilter
              )}
            />
          </div>
        ))
      ) : (
        <RadioGroup
          direction="column"
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setSelectedOptions({ ...selectedOptions, [selectedFilter]: [e.target.value] })
          }
          className="gap-[20px]"
          value={selectedOptions[selectedFilter]?.[0]}
          name={selectedFilter}
          options={filteredOptionsData as RadioOptions[]}
        />
      )}
    </div>
  );
};

export default NormalOptions;
